import React, { useState } from 'react'
import { Button } from 'antd'
import {
    AlignLeftOutlined,
    FullscreenExitOutlined,
    FullscreenOutlined
} from '@ant-design/icons'
import styled from 'styled-components'
import { Controlled as CodeMirror } from 'react-codemirror2'
import jsbeautifier from 'js-beautify'

const Contrainer = styled.div`
    .code-editor-wrapper {
        border-radius: 3px;
        overflow: hidden;
        .toolbar {
            background-color: #e9e9e9;
            text-align: right;
        }
        &.fullscreen {
            position: fixed;
            top: 10%;
            bottom: 10%;
            left: 10%;
            right: 10%;
            z-index: 999999;
            .CodeMirror {
                height: calc(80vh - 24px);
            }
        }
    }
    .code-editor-overlay {
        position: fixed;
        background: rgba(0, 0, 0, 0.45);
        z-index: 99999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
`

var beautifyOptions = {
    indent_size: 2,
    html: {
        end_with_newline: true,
        js: {
            indent_size: 2
        },
        css: {
            indent_size: 2
        }
    },
    css: {
        indent_size: 2
    },
    js: {
        'preserve-newlines': true
    }
}

const CodeEditor = ({ T, language = 'htmlmixed', value, onChange }) => {
    let [isFullScreen, setIsFullScreen] = useState(false)

    function onBeautify() {
        let code = value
        if (language == 'css') {
            code = jsbeautifier.css(code, beautifyOptions)
        } else {
            code = jsbeautifier.html(code, beautifyOptions)
        }
        onChange && onChange(code)
    }

    function onToggleExpand() {
        setIsFullScreen(!isFullScreen)
    }

    return (
        <Contrainer>
            {isFullScreen && (
                <div
                    className="code-editor-overlay"
                    onClick={() => onToggleExpand()}></div>
            )}
            <div
                className={`code-editor-wrapper ${
                    isFullScreen ? 'fullscreen' : ''
                }`}>
                <div className="toolbar">
                    <Button
                        type="text"
                        size="small"
                        title="Format code"
                        style={{ marginRight: 3 }}
                        icon={<AlignLeftOutlined />}
                        onClick={() => onBeautify()}
                    />
                    <Button
                        type="text"
                        size="small"
                        title={isFullScreen ? 'Exit' : 'Fullscreen'}
                        icon={
                            isFullScreen ? (
                                <FullscreenExitOutlined />
                            ) : (
                                <FullscreenOutlined />
                            )
                        }
                        onClick={() => onToggleExpand()}
                    />
                </div>
                <CodeMirror
                    value={value}
                    options={{
                        mode: language,
                        theme: 'dracula',
                        lineNumbers: true
                    }}
                    onBeforeChange={(editor, data, value) => {
                        onChange(value)
                    }}
                    onChange={(editor, data, value) => {}}
                />
            </div>
        </Contrainer>
    )
}

export default CodeEditor
